import store from "../store";
export function useBuildPageForm() {
  let localeColumns = store.getters.localeColumns;
  return {
    name: "",
    type_id: null,
    title: {
      ...localeColumns
    },
    parent_id: null,
    description: {
      ...localeColumns
    },
    sub_title: {
      ...localeColumns
    },
    sections: [],
    hidden: false,
    icon: "",
    seq: 0
  };
}
export function useBuildSectionItem() {
  let localeColumns = store.getters.localeColumns;
  return {
    seq: 0,
    hidden: false,
    image_url: "",
    type_id: null,
    redirect_url: "",
    video_cover_url: "",
    video_url: "",
    title: { ...localeColumns },
    icon: "",
    description: {
      ...localeColumns
    },
    sub_title: {
      ...localeColumns
    },
    videos: [],
    images: [],
    content: ""
  };
}
